import React, { useState, useEffect } from 'react';
import { Fragment } from 'react';
import { Card, CardBody, UncontrolledTooltip } from 'reactstrap';
import FalconCardHeader from '../common/FalconCardHeader';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';

import Publications from '../publication/Publications';

const MarketNewPublications = (props) => {
    
  const [appliedFilter, setAppliedFilter] = useState({
    downloadFrom: new Date(new Date().getTime() - 24 * 60 * 60 * 1000),
    industries: [{ name: props.filteredIndustry }],
    initialized: true,
    searchIssued: new Date()
  });

  useEffect(() => {
    setAppliedFilter(
      {        
        downloadFrom: new Date(new Date().getTime() - 24 * 60 * 60 * 1000),
        // downloadTo: new Date(new Date().setHours(0,0,0,0)),
        // kdqLastmodFrom: undefined,
        // kdqLastmodTo: undefined,
        industries: [{ name: props.filteredIndustry }],
        initialized: true,
        searchIssued: new Date()
      }
    );
  }, [props.filteredIndustry, props.updateRequest])

  let columnsSmall = [
    { colId: 'downloadDate' },                        
    { colId: 'contractingBody' },                        
    { colId: 'title' }
    
  ]

  let columnsMedium = [
    { colId: 'downloadDate' },                        
    { colId: 'contractingBodyLogo' },
    { colId: 'contractingBody' },                        
    { colId: 'title' },
    { colId: 'contractor' },
    { colId: 'totalValue' },
  ];

  let columnsLarge = [
    { colId: 'downloadDate' },                        
    { colId: 'contractingBodyLogo' },
    { colId: 'contractingBody' },                    
    { colId: 'stage' },
    { colId: 'label' },
    { colId: 'title' },
    { colId: 'contractor' },
    { colId: 'totalValue' },
    { colId: 'numberOfFiles' }
  ];

  let columns = columnsSmall;

  if (window.innerWidth > 768) {
    columns = columnsMedium;
  }

  if (window.innerWidth > 1900) {
    columns = columnsLarge;
  }

  return (    
    <Fragment>      
          <Card>
            <FalconCardHeader
              className="pb-0"
              title={
              <Fragment>                  
                  <span style={{ display: 'inline' }}>Neue Veröffentlichungen&nbsp;</span>
                  <FontAwesomeIcon
                  icon={['far', 'question-circle']}
                  transform="shrink-1"
                  className="text-400"
                  id="MarketNewPublicationsTooltip"
                  style={{ display: 'inline' , verticalAlign: 'top'}}
                  />
                  <UncontrolledTooltip placement="bottom" target="MarketNewPublicationsTooltip">
                  Die neuesten 200 Veröffentlichungen.
                  </UncontrolledTooltip>
              </Fragment>
              }
              light={false}
              titleTag="h6"
            >                          
            </FalconCardHeader>            
            
                    <CardBody>
                    <Publications
                      title="Neue Veröffentlichungen"
                      toolTip="Veröffentlichungen passend zur Suche."
                      columns={columns}
                      filter={appliedFilter}
                      records={200}
                    />
                    </CardBody>                
            
            
            
          </Card>          
    </Fragment>
  );
};

export default MarketNewPublications;